import { useState, useEffect } from 'react';
import componentNotifier from '../../../services/wss/ComponentNotifier';
import errorEngine from './ErrorEngine';

const _eventName = 'errorStateChanged';

/**
 * useErrorSnack — observer hook for ErrorEngine.
 * Subscribes to ComponentNotifier errorStateChanged events.
 * Returns current first error and dismiss handler.
 * @returns {{ error: { source: string, message: string }|null, dismiss: Function }}
 */
export function useErrorSnack() {
    // this is a React trick to for repaint
    const [, forceRepaint] = useState(0);

    useEffect(() => {
        /**
         * Triggers repaint when error queue changes.
         */
        const handleNotify = () => {
            forceRepaint((n) => n + 1);
        };

        // subscribe on event namee, increase counter to
        // force React component to "render"
        // but it does not render any thing
        // it returns an object with error en dismmis function
        const unsub = componentNotifier.subscribe(_eventName, handleNotify);
        return () => unsub();
    }, []);

    // so this would normally render components
    // instead of rendering we return
    // an object with new data
    return {
        error: errorEngine.getFirst(),
        dismiss: errorEngine.dismiss,
    };
}
